import Vue from 'vue'

import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4465b420 from 'nuxt_plugin_sentryserver_4465b420' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7813b468 from 'nuxt_plugin_sentryclient_7813b468' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_47557304 from 'nuxt_plugin_plugin_47557304' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_recaptcha_7249ea9b from 'nuxt_plugin_recaptcha_7249ea9b' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_nuxtplugin67d9267d_c07c1196 from 'nuxt_plugin_nuxtplugin67d9267d_c07c1196' // Source: ./nuxt.plugin.67d9267d.js (mode: 'server')
import nuxt_plugin_vuescrollto_772c2a5d from 'nuxt_plugin_vuescrollto_772c2a5d' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_distplugin44f599a2_2c9999b4 from 'nuxt_plugin_distplugin44f599a2_2c9999b4' // Source: ./dist.plugin.44f599a2.mjs (mode: 'all')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_coreplugin8ae3a902_efabd736 from 'nuxt_plugin_coreplugin8ae3a902_efabd736' // Source: ./core.plugin.8ae3a902.ts (mode: 'all')
import nuxt_plugin_pluginse2etesting8a8972c2_1bcf1297 from 'nuxt_plugin_pluginse2etesting8a8972c2_1bcf1297' // Source: ./plugins.e2e-testing.8a8972c2.js (mode: 'all')
import nuxt_plugin_modulepluginea4a885a_3ed17aa1 from 'nuxt_plugin_modulepluginea4a885a_3ed17aa1' // Source: ./module.plugin.ea4a885a.mjs (mode: 'all')
import nuxt_plugin_deviceplugin_001a0492 from 'nuxt_plugin_deviceplugin_001a0492' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_workbox_568eec48 from 'nuxt_plugin_workbox_568eec48' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_metaplugin_737b6b5b from 'nuxt_plugin_metaplugin_737b6b5b' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_782310cf from 'nuxt_plugin_iconplugin_782310cf' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_GoogleAnalitycs4_417bcc1d from 'nuxt_plugin_GoogleAnalitycs4_417bcc1d' // Source: ../plugins/GoogleAnalitycs4 (mode: 'all')
import nuxt_plugin_tokenexpired_ca1e20ca from 'nuxt_plugin_tokenexpired_ca1e20ca' // Source: ../plugins/token-expired (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_fcPlugin_5a846bc6 from 'nuxt_plugin_fcPlugin_5a846bc6' // Source: ../plugins/fcPlugin (mode: 'all')
import nuxt_plugin_dompurify_9e093c4a from 'nuxt_plugin_dompurify_9e093c4a' // Source: ../plugins/dompurify (mode: 'all')
import nuxt_plugin_storeConfigPlugin_234467e0 from 'nuxt_plugin_storeConfigPlugin_234467e0' // Source: ../plugins/storeConfigPlugin (mode: 'all')
import nuxt_plugin_loginPushPlugin_35ae0479 from 'nuxt_plugin_loginPushPlugin_35ae0479' // Source: ../plugins/loginPushPlugin.client (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'all')
import nuxt_plugin_pwacheck_15cf7c02 from 'nuxt_plugin_pwacheck_15cf7c02' // Source: ../plugins/pwa-check (mode: 'all')
import nuxt_plugin_urlResolver_161941aa from 'nuxt_plugin_urlResolver_161941aa' // Source: ../modules/storyblok/plugins/urlResolver.ts (mode: 'all')
import nuxt_plugin_meta_598eade0 from 'nuxt_plugin_meta_598eade0' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"EXTRACTS.PRO - EXTRACTS.PRO","meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1"},{"name":"robots","content":"index, follow"},{"hid":"og:locale","property":"og:locale","content":"pl_PL"},{"hid":"og:site_name","property":"og:site_name","content":"EXTRACTS.PRO"},{"hid":"og:image","property":"og:image","content":"\u002Fseo\u002FogImage.jpg"},{"hid":"description","name":"description","content":"Oficjalny Sklep Producenta Biostymulatorów i Mieszanek Paszowych Uzupełniających - Extracts.Pro"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4465b420 === 'function') {
    await nuxt_plugin_sentryserver_4465b420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7813b468 === 'function') {
    await nuxt_plugin_sentryclient_7813b468(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_47557304 === 'function') {
    await nuxt_plugin_plugin_47557304(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_7249ea9b === 'function') {
    await nuxt_plugin_recaptcha_7249ea9b(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_nuxtplugin67d9267d_c07c1196 === 'function') {
    await nuxt_plugin_nuxtplugin67d9267d_c07c1196(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_772c2a5d === 'function') {
    await nuxt_plugin_vuescrollto_772c2a5d(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_distplugin44f599a2_2c9999b4 === 'function') {
    await nuxt_plugin_distplugin44f599a2_2c9999b4(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (typeof nuxt_plugin_coreplugin8ae3a902_efabd736 === 'function') {
    await nuxt_plugin_coreplugin8ae3a902_efabd736(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginse2etesting8a8972c2_1bcf1297 === 'function') {
    await nuxt_plugin_pluginse2etesting8a8972c2_1bcf1297(app.context, inject)
  }

  if (typeof nuxt_plugin_modulepluginea4a885a_3ed17aa1 === 'function') {
    await nuxt_plugin_modulepluginea4a885a_3ed17aa1(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_001a0492 === 'function') {
    await nuxt_plugin_deviceplugin_001a0492(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_workbox_568eec48 === 'function') {
    await nuxt_plugin_workbox_568eec48(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_737b6b5b === 'function') {
    await nuxt_plugin_metaplugin_737b6b5b(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_782310cf === 'function') {
    await nuxt_plugin_iconplugin_782310cf(app.context, inject)
  }

  if (typeof nuxt_plugin_GoogleAnalitycs4_417bcc1d === 'function') {
    await nuxt_plugin_GoogleAnalitycs4_417bcc1d(app.context, inject)
  }

  if (typeof nuxt_plugin_tokenexpired_ca1e20ca === 'function') {
    await nuxt_plugin_tokenexpired_ca1e20ca(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_fcPlugin_5a846bc6 === 'function') {
    await nuxt_plugin_fcPlugin_5a846bc6(app.context, inject)
  }

  if (typeof nuxt_plugin_dompurify_9e093c4a === 'function') {
    await nuxt_plugin_dompurify_9e093c4a(app.context, inject)
  }

  if (typeof nuxt_plugin_storeConfigPlugin_234467e0 === 'function') {
    await nuxt_plugin_storeConfigPlugin_234467e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_loginPushPlugin_35ae0479 === 'function') {
    await nuxt_plugin_loginPushPlugin_35ae0479(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (typeof nuxt_plugin_pwacheck_15cf7c02 === 'function') {
    await nuxt_plugin_pwacheck_15cf7c02(app.context, inject)
  }

  if (typeof nuxt_plugin_urlResolver_161941aa === 'function') {
    await nuxt_plugin_urlResolver_161941aa(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_598eade0 === 'function') {
    await nuxt_plugin_meta_598eade0(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    app,
    router
  }
}

export { createApp, NuxtError }
